<tt-page>
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-button-goto [ttText]="'new'" (ttClick)="goToFunc('orderlinecreditcause')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list *ngIf="!!itemsListCauses" class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListCauses"></tt-list>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-button class="col-xs-12 sp-0" tt-text="new" tt-click="vm.goToFunc('orderlinecreditcause')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
    </tt-card>

    <im-list-directive class="col-xs-12 col-md-6 sp-0" list-items="vm.model.itemsListCauses" badge="" ltype="" design-var="s12t0"></im-list-directive>
</tt-page>-->
